"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapabilityDefinition = exports.CAPABILITY_CATALOG = void 0;
const constants_1 = require("./constants");
const enums_1 = require("./contracts/enums");
const SHARED_APPLIES_TO = [enums_1.RegistryType.Company, enums_1.RegistryType.Fund];
const FUND_ONLY = new Set([
    constants_1.FeatureIds.REDEMPTIONS,
    constants_1.FeatureIds.FATCA_CRS,
    constants_1.FeatureIds.DISTRIBUTIONS,
    constants_1.FeatureIds.ALLOW_OWNER_ID_HEALING,
    constants_1.FeatureIds.ALLOW_IMPORT_HISTORY,
    constants_1.FeatureIds.IMPORT_ADDITIONAL_CONTACTS,
    constants_1.FeatureIds.USE_NEW_SUBSCRIPTION_MODEL,
    constants_1.FeatureIds.TRUST_SMSF_REDESIGN,
    constants_1.FeatureIds.USE_YIELD_ACCRUAL,
    constants_1.FeatureIds.ERC7540_VAULT,
    constants_1.FeatureIds.INTERNATIONAL_BANK_ACCOUNTS,
]);
const ALWAYS_ON = new Set([
    constants_1.FeatureIds.FATCA_CRS,
    constants_1.FeatureIds.ALLOW_IMPORT_HISTORY,
    constants_1.FeatureIds.IMPORT_ADDITIONAL_CONTACTS,
    constants_1.FeatureIds.TRUST_SMSF_REDESIGN,
]);
const COMPANY_ONLY = new Set([constants_1.FeatureIds.COMBINE_484S, constants_1.FeatureIds.BGL360_FEATURE]);
const appliesToFor = (id) => {
    if (FUND_ONLY.has(id)) {
        return [enums_1.RegistryType.Fund];
    }
    if (COMPANY_ONLY.has(id)) {
        return [enums_1.RegistryType.Company];
    }
    return SHARED_APPLIES_TO;
};
const enablementFor = (id) => {
    if (id === constants_1.FeatureIds.REDEMPTIONS) {
        return { kind: "companySetting", field: "redemptionConfig.allowRedemptions" };
    }
    if (ALWAYS_ON.has(id)) {
        return { kind: "alwaysOn" };
    }
    return { kind: "featureAssignment" };
};
/** Published optional-capability table. `unit-registry` is identity, not a row. */
exports.CAPABILITY_CATALOG = Object.values(constants_1.FeatureIds).map((id) => ({
    id,
    appliesTo: appliesToFor(id),
    enablement: enablementFor(id),
}));
const getCapabilityDefinition = (id) => exports.CAPABILITY_CATALOG.find((row) => row.id === id);
exports.getCapabilityDefinition = getCapabilityDefinition;
//# sourceMappingURL=capabilityCatalog.js.map